const config = {
  ENV: process.env.REACT_APP_ENV,
  API_ENDPOINT: process.env.REACT_APP_API_URL
}

export default config;